import { useState } from 'react';
import { runOnJS, useAnimatedReaction, useSharedValue, } from 'react-native-reanimated';
import { useAnimatedPlayerIndex } from './useAnimatedPlayerIndex';
const CLOSED_PERCENT = 0.8;
const FLIP_FLOP_VARIANCE = 0.5;
export const useIsPlayerMinimized = () => {
    const animatedPlayerIndex = useAnimatedPlayerIndex();
    const [isMinimized, setIsMinimized] = useState(true);
    const sharedIsMinimized = useSharedValue(isMinimized);
    useAnimatedReaction(() => animatedPlayerIndex.value, (currentValue, previousValue) => {
        const isCurMin = currentValue < CLOSED_PERCENT;
        const variance = Math.abs(currentValue - (previousValue || 0));
        const isDiff = isCurMin !== sharedIsMinimized.value;
        const flipFlop = variance > FLIP_FLOP_VARIANCE;
        if (isDiff && !flipFlop) {
            sharedIsMinimized.value = isCurMin;
            runOnJS(setIsMinimized)(isCurMin);
        }
    });
    return isMinimized;
};
//# sourceMappingURL=useIsPlayerMinimized.js.map